import { useState } from "react";

type AccordionItem = {
  id: string;
  question: string;
  answer: string;
};

type AccordionProps = {
  items: AccordionItem[];
  defaultOpenId?: string;
};

export default function Accordion({ items, defaultOpenId }: AccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openId === item.id;
        return (
          <div
            key={item.id}
            className={`rounded-lg border transition-colors ${
              isOpen ? "border-primary-300 bg-primary-50/60" : "border-background-200 bg-background-50"
            }`}
          >
            <h3>
              <button
                type="button"
                onClick={() => toggle(item.id)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-5 py-4 cursor-pointer"
              >
                <span className="flex items-start gap-3">
                  <span
                    className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-medium ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span
                    className={`text-sm md:text-base font-medium leading-relaxed ${
                      isOpen ? "text-primary-800" : "text-foreground-900"
                    }`}
                  >
                    {item.question}
                  </span>
                </span>
                <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-600">
                  <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg`} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 md:px-5 pb-5 pl-[3.25rem] md:pl-[3.75rem]">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}